<h2 mat-dialog-title>{{ 'DOMAIN_AUTHORIZATION.DOMAINS_DIALOG.HEADER' | translate }}</h2>
<mat-dialog-content>
  @if (allDomains$ | glxyAsyncStatus | async; as data) {
    @switch (data.status) {
      <!-- Begin state handling -->
      @case ('loaded') {
        <mat-selection-list [multiple]="false" [hideSingleSelectionIndicator]="true">
          @for (domain of data.value; track domain) {
            <mat-list-option>
              <email-domain-status-and-name
                [data]="{ domain: domain.domain, sender: domain.sender }"
                (clicked)="self.close()"
                (domainChangeRequested)="handleDomainChangeRequested($event, true)"
                (invalidDomainChangeRequested)="handleDomainChangeRequested($event, false)"
              ></email-domain-status-and-name>
            </mat-list-option>
          }
        </mat-selection-list>
      }
      @case ('loading') {
        <glxy-loading-spinner></glxy-loading-spinner>
      }
      @case ('error') {
        <glxy-empty-state [size]="'small'">
          <glxy-empty-state-hero>
            <mat-icon color="warn">error</mat-icon>
          </glxy-empty-state-hero>
          <glxy-empty-state-title>{{ 'DOMAIN_AUTHORIZATION.DOMAINS_DIALOG.ERROR' | translate }}</glxy-empty-state-title>
          <p>{{ data.error }}</p>
        </glxy-empty-state>
      }
      <!-- End state handling -->
    }
  }
</mat-dialog-content>
<mat-dialog-actions>
  <!-- TODO: Support more than two domains [EM-1678] -->
  @if ((allDomains$ | async)?.length < 2) {
    <div class="dialog-secondary-actions">
      <button mat-button color="primary" (click)="handleNewDomainRequested()">
        {{ 'DOMAIN_AUTHORIZATION.NEW_DOMAIN_DIALOG.ADD_DOMAIN' | translate }}
      </button>
    </div>
  }
  <button mat-stroked-button matDialogClose>
    {{ 'COMMON.ACTION_LABELS.CANCEL' | translate }}
  </button>
</mat-dialog-actions>
